import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { RoutingModule } from './app-routing.module';
import { SharedModule } from '@shared/shared.module';
import { JwtModule } from '@auth0/angular-jwt';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { IdleLogoutModule } from '@shared/component/idle-logout/idle-logout.module';
import { TraceService, createErrorHandler } from '@sentry/angular';
import { Router } from '@angular/router';
import { APP_INITIALIZER } from '@angular/core';
import { environment } from '@env/environment';
import { CommonModule } from 'taxtank-core/common';
import { CoreModule } from 'taxtank-core';
import { ConfirmationService } from 'primeng/api';
import { MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS, MatButtonToggleDefaultOptions } from '@angular/material/button-toggle';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { APP_PRIME_PRESET } from './app.prime.preset';
import { TourComponent } from '@shared/component/tour/tour.component';
import { ReactiveFormConfig } from '@rxweb/reactive-form-validators';

export function tokenGetter(): string {
  return localStorage.getItem('token');
}

export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    SharedModule,
    BrowserModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      },
      defaultLanguage: 'en'
    }),
    RoutingModule,
    BrowserAnimationsModule,
    JwtModule.forRoot({
      config: { tokenGetter }
    }),
    IdleLogoutModule,
    CoreModule,
    CommonModule.forRoot(environment),
    TourComponent
  ],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: ErrorHandler,
      useValue: createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {
      },
      deps: [TraceService],
      multi: true,
    },
    {
      provide: MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS,
      useValue: {
        hideSingleSelectionIndicator: true
      } as MatButtonToggleDefaultOptions
    },
    ConfirmationService,
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: APP_PRIME_PRESET,
        options: {
          darkModeSelector: false,
        }
      }
    }),
    provideHttpClient(withInterceptorsFromDi())
  ]
})

export class AppModule {
  constructor() {
    ReactiveFormConfig.set({
      validationMessage: {
        required: 'This field is required',
        minLength: 'Must be at least {{1}} characters',
        maxLength: 'Cannot exceed {{1}} characters',
      }
    });
  }
}
